import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { GlobalService } from '../services/global.service';

export const publicOnlyGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const globalService = inject(GlobalService);
  const router = inject(Router);

  // Se logado, redireciona para a área adequada
  if (authService.isLoggedin(globalService.loggedUserClass)) {
    const target = globalService.loggedUserClass.NavigateTo || '/';
    console.log('[PUBLIC GUARD] 🛑 Utilizador já logado. Redirecionando para:', target);
    router.navigate([target]);
    return false;
  }

  return true;
};
